import { TextContainer } from 'components/container'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Section = styled.div`
  ${mq.smallOnly} {
    display: flex;
    flex-direction: column;
  }
`

export const Figure = styled.figure`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 10vw;
  max-width: 100%;
  text-align: center;

  ${mq.medium} {
    margin-top: 10rem;
  }

  ${mq.large} {
    position: relative;
    width: max-content;
  }

  img {
    margin: -10% -10% -3%;

    ${mq.large} {
      margin: -10rem -5rem;
    }
  }
`

export const Description = styled.figcaption`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.2rem;
  ${mq.smallOnly} {
    * {
      line-height: 1.25;
    }
  }

  > * {
    display: flex;
    align-items: center;
    flex: 1;
    max-width: 40rem;
    max-width: 28rem;

    span {
      content: '';
      display: block;
      width: 1.6em;
      height: 1.6em;
      margin: 0 2rem;
      border-radius: 50%;
      flex-shrink: 0;
      opacity: 0.75;
      background-color: var(--theme-color);
    }

    &:last-child span {
      ${mq.large} {
        order: -1;
      }
    }
  }

  ${mq.ltLarge} {
    > * {
      flex-direction: column;

      &:first-child span {
        order: -1;
      }
    }
  }

  ${mq.medium} {
    font-size: 1.4rem;
  }

  ${mq.large} {
    position: absolute;
    top: 50%;
    left: 100%;
    transform: translateY(-50%);
    width: 30rem;
    text-align: left;
  }
`

export const Image = styled.img`
  display: block;
  max-width: max-content;
  width: 100%;

  ${mq.large} {
    margin: 0 5rem;
    width: 38rem;
  }
`

export const FlagColors = styled(TextContainer)`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  justify-content: center;
  gap: 2rem;
  margin-top: 8rem;
  margin-bottom: 8rem;
  order: 1;

  ${mq.medium} {
    gap: 5rem;
  }

  img {
    display: block;
    margin: 0 auto;
    border-radius: 50%;

    ${mq.smallOnly} {
      max-width: 5rem;
    }
  }

  h3 {
    width: 100%;
    flex-shrink: 0;
    text-align: left;

    ${mq.medium} {
      display: none;
    }
  }

  h4 {
    margin: 1.9rem 0 0;
    font-size: 1.5rem;
    font-weight: 800;

    ${mq.medium} {
      margin: 3rem 0 1.5rem;
      font-size: 2.4rem;
    }
  }

  p {
    font-size: 1rem;
    max-width: 15em;

    ${mq.medium} {
      font-size: 1.4rem;
    }
  }

  > div {
    ${mq.smallOnly} {
      flex: 1;
    }
  }
`
